import { View, Text, StyleSheet,Image } from 'react-native';
export default function About() {
  return (
    <View style={styles.container}>

      <Text style={styles.h2}>About Me</Text>
      <View style={styles.wrapper}>
     <Text style={styles.p}>
       I am experienced in building and maintaining responsive websites and
       mobile applications
       I have exceptional analytical and problem-solving skills with enthusiasm
       and ambition tо complete projects tо the highest standard.{" "}
       I have experience in designing and developing mobile and web
       applications using React Native, React.Js, JavaScript, HTML5, CSS and
       Bootstrap
       My positive attitude and excellent teamwork skills enable me to deliver
       projects on time while collaborating with cross-functional teams.
      </Text>
     {/* <Image
       style={styles.Aboutt} 
        source={require('../../assets/Aboutt.jpg')}
        alt="" /> */}
     </View>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  wrapper:{
   alignItems:'center',
  },
  h2: {
    fontSize: 50,
    textAlign: "center",
    color: "#000",
    fontWeight: "bold",
    marginBottom:25
  },
  p: {
    marginTop: 15,
    marginLeft: 20,
    alignSelf: "flex-start",
    color: "#000",
    maxWidth:1000,
    fontSize:20


  },
  Aboutt:{
    width:300,
    height:300,
    alignSelf:'center',

    
   
  },

})